const StockTransfer = {

    // FIELDS
    "ware_house": "Ware House",
    "sale_type": "Sale Type",
    "remark": "Remark",
    "search": "Search",
    "item": "Item",
    "rate": "Rate",
    "quantity": "Quantity",
    "unit": "Unit",
    "vat": "VAT (%)",
    "sub_total": "Sub Total",
    "total": "Total",

    // BUTTON
    "clear_item": "Clear 0 Pricing Items",

    // PAGE HEADER
    "stock_transfer": "Stock Transfer",

    // SWEET ALERT
    "pricing": "Pricing",
    "pricing_message": "Some of items pricing's are not updated please remove those items",

    // ERROR
    "error_ware_house": "Select Ware House",
    "error_sale_type": "Select Sale Type",
    "error_remark": "Enter Remarks",
    "error_item": "Select Item",
    "error_rate": "Enter Rate",
    "error_quantity": "Enter Quantity",
    "error_positive": "Positive Only",
    "error_vat": "VAT is Required",

    // TABLE HEADER
    "table_stock_id": "STOCK ID",
    "table_ware_house": 'WARE HOUSE',
    "table_sale_type": "SALE TYPE",

}

export default StockTransfer;